<template>
  <div v-if="display">
    <h1 class="page-title"><i class="fal fa-desktop-alt"></i> Gränssnitt</h1>
    <h3>Utseende</h3>
    <div class="columns">
      <div class="column is-one-quarter">
        <label class="label">Textstorlek</label>
        <div class="select">
          <select v-model="userSettings.fontSize" @change="setFontSize(userSettings.fontSize)">
            <option value="16">Normal</option>
            <option value="18">Stor</option>
            <option value="20">Gigantisk</option>
          </select>
        </div>
      </div>
    </div>

    <h3>Antal rader</h3>
    <div class="columns">
      <div class="column is-one-quarter">
        <label class="label">Projektlistor</label>
        <div class="select">
          <select v-model="userSettings.itemsPerPageProjects">
            <option value="0">0 (visa alla)</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-quarter">
        <label class="label">Insatslistor</label>
        <div class="select">
          <select v-model="userSettings.itemsPerPageWorkOrders">
            <option value="0">0 (visa alla)</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-quarter">
        <label class="label">Övriga listor</label>
        <div class="select">
          <select v-model="userSettings.itemsPerPageDefault">
            <option value="0">0 (visa alla)</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
      </div>
    </div>

    <!-- <h3>Insatser</h3>
    <label class="label">Status Alla visar</label>
    <div><label><input type="checkbox" :checked="getValue('Quoted')" @change="check('Quoted')" /> Offererad</label></div>
    <div><label><input type="checkbox" :checked="getValue('Planned')" @change="check('Planned')" /> Planerad</label></div>
    <div><label><input type="checkbox" :checked="getValue('Started')" @change="check('Started')" /> Pågående</label></div>
    <div><label><input type="checkbox" :checked="getValue('Registered')" @change="check('Registered')" /> Registrerad</label></div>
    <div><label><input type="checkbox" :checked="getValue('Invoiced')" @change="check('Invoiced')" /> Fakturerad</label></div>
    <div><label><input type="checkbox" :checked="getValue('Cancelled')" @change="check('Cancelled')" /> Makulerad</label></div> -->

    <br>

    <button class="button is-success" @click="save">Spara</button>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  data () {
    return {
      display: false,
      loadedFontSize: null,
      userSettings: {}
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('userSettings', ['getCurrentUserSettings', 'saveCurrentUserSettings']),
    getValue (key) {
      return this.userSettings.workOrderAllShows.some(x => x === key)
    },
    check (key) {
      const index = this.userSettings.workOrderAllShows.indexOf(key)
      if (index > -1) {
        this.userSettings.workOrderAllShows.splice(index, 1)
      } else {
        this.userSettings.workOrderAllShows.push(key)
      }
    },
    save () {
      this.saveCurrentUserSettings(this.userSettings).then(userSettings => {
        this.userSettings = userSettings
        this.loadedFontSize = this.userSettings.fontSize
      })
    },
    setFontSize (fontSize) {
      let previewElement = document.getElementById('html')
      previewElement.style.fontSize = fontSize + 'px'
    }
  },

  mounted () {
    this.getCurrentUserSettings().then(userSettings => {
      this.userSettings = userSettings
      this.loadedFontSize = userSettings.fontSize
      this.display = true
    })
  },

  beforeRouteLeave (to, from, next) {
    this.setFontSize(this.loadedFontSize)
    next()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/PreferencesPage.vue